import { wallet as o } from "../store/index.mjs";
import { ERROR_CONNECT_WALLET as n } from "./errors.mjs";
import { useHODLPoolContract as r } from "../store/hodlPoolContract.mjs";
async function u(t) {
  return (await r().poolData(t)).totalStakeAmount;
}
function i(t) {
  const e = o?.getAddress();
  if (e === void 0) throw n;
  return r().getStakingAmountByPoolID(e, t);
}
function f(t) {
  const e = o?.getAddress();
  if (e === void 0) throw n;
  return r().getPendingReward(t, e);
}
function l() {
  return r().rewarder();
}
function c(t, e) {
  return r(!0).stake(t, e);
}
function m(t, e) {
  return r(!0).unstake(t, e);
}
function w(t, e) {
  return r(!0).unstakeAndRedeemReward(t, e);
}
function g(t) {
  return r(!0).redeemRewards(t);
}
function R(t) {
  return r().poolInfos(t);
}
function k() {
  return r().lastPoolId();
}
function p(t) {
  if (o?.getAddress() === void 0) throw n;
  return r(!0).redeemRewardsByList(t);
}
export {
  f as getPendingReward,
  u as getPoolTotalStake,
  p as getRewardFromHodlPools,
  i as getStakingAmountByPoolID,
  k as lastPoolId,
  R as poolInfos,
  g as redeemRewards,
  l as rewarder,
  c as stake,
  m as unstake,
  w as unstakeAndRedeemReward
};
//# sourceMappingURL=hodl_pool.mjs.map
